import { useAuth } from "@/components/auth/AuthProvider";
import { useTranslation } from "react-i18next";
import SavedProducts from "@/components/profile/SavedProducts";
import ProfileSettings from "@/components/profile/ProfileSettings";
import MyReviews from "@/components/profile/MyReviews";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

const Profile = () => {
  const { user } = useAuth();
  const { t } = useTranslation();

  if (!user) {
    return <div>{t("auth.pleaseLogin")}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">{t("profile.myProfile")}</h1>
      <Tabs defaultValue="saved" className="space-y-6">
        <TabsList>
          <TabsTrigger value="saved">{t("profile.savedProducts")}</TabsTrigger>
          <TabsTrigger value="reviews">{t("profile.myReviews")}</TabsTrigger>
          <TabsTrigger value="settings">{t("profile.settings")}</TabsTrigger>
        </TabsList>
        <TabsContent value="saved">
          <section>
            <h2 className="text-xl font-semibold mb-4">{t("profile.savedProducts")}</h2>
            <SavedProducts />
          </section>
        </TabsContent>
        <TabsContent value="reviews">
          <section>
            <h2 className="text-xl font-semibold mb-4">{t("profile.myReviews")}</h2>
            <MyReviews />
          </section>
        </TabsContent>
        <TabsContent value="settings">
          <section>
            <h2 className="text-xl font-semibold mb-4">{t("profile.settings")}</h2>
            <ProfileSettings />
          </section>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Profile;